module.exports = __webpack_public_path__ + "static/img/lysys.bccef4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/lysys.png
// module id = 2C/r
// module chunks = 1